export default {
  key: "éxito",
  Things: "Cosas",
  "Upload Date": "Fecha de carga",
  Duration: "Duración",
  Features: "Características",
  "Edit Image": "Editar imagen",
  Title: "Título",
  Description: "Descripción",
  "New Image": "Nueva imagen",
  Image: "Imagen",
  Images: "Imágenes",
  Tags: "Etiquetas",
  "Save & close": "Guardar cerrar",
  Type: "Escribe",
  Edit: "Editar",
  Delete: "Borrar",
  "Go back": "Regresa",
  "New item": "Nuevo artículo",
  Id: "Id",
  "Upload Image": "Cargar imagen",
  "Layouts Timeline": "Línea de tiempo de diseños",
  Date: "Fecha",
  "Back stage": "backstage",
  Front: "Frente",
  items: "elementos",
  "Navigate: Things": "Navegar: Cosas",
  Orientation: "Orientación",
  back: "espalda",
  front: "frente",
  gallery: "galería",
  preview: "avance",
  New: "Nuevo",
  search: "búsqueda",
};
